export default {
  zh: {
    workTitle: "你在马来西亚设立公司准备从事什么业务？",
    causeTitle: "公司在马来西亚设立的原因(多选项，至少选一项)",
    atDutiesTitle: "(拟设)公司的申请人/董事/股东是否为政治敏感人士，即在马来西亚境内、或其他国籍和地区，或任何一个国际组织目前担任敏感的政治职务？",
    onceDutiesTitle: "(拟设)公司的申请人/董事/股东是否为政治敏感人士，即在马来西亚境内、或其他国籍和地区，或任何一个国际组织曾经担任敏感的政治职务？",
  },
  en: {
    workTitle: "What kind of business do you intend to do?",
    causeTitle: "Why are you interested in incorporating your business in Malaysia? (Multiply choices, to select at least 1)",
    atDutiesTitle:
      "Are any of applicant/director(s)/shareholder(s) of the proposed company a political exposed person, that is, a person who is or has been entrusted with any prominent public function in Malaysia, a country or territory outside Malaysia, or by an international organization at present?",
    onceDutiesTitle:
      "Are any of applicant/director(s)/shareholder(s) of the proposed company a political exposed person, that is, a person who is or has been entrusted with any prominent public function in Malaysia, a country or territory outside Malaysia, or by an international organization who has stepped down from his prominent public function?",
  },
};
